import { ICase } from "@/models/case";
import { CaseLabels, Label } from "@/models/labels";
import { log } from "@/core/logger";

// Labels

const constructLabels = (labels: Label[], labelTissueConfig: any): Label[] => {
  try {
    return labels.reduce(function (result, label) {
      if (labelTissueConfig[label.key]) {
        return result.concat({
          key: label.key,
          likelihood: label.likelihood,
          title: labelTissueConfig[label.key].title,
          color: labelTissueConfig[label.key].color,
        });
      }
      return result;
    }, [] as any);
  } catch (error) {
    log((error as any).message);
    throw new Error("failed constructing slide labels");
  }
};

export const constructAllLabels = (
  cases: ICase[],
  labels: CaseLabels,
  insightsConfig: any
): CaseLabels | undefined => {
  try {
    for (const caseId in labels) {
      const caseObj = cases.find((caseObj: ICase) => caseObj.caseId === caseId);
      if (!caseObj) {
        log(`Error: unable to construct labels, case data mismatch`);
        // Ignore labels without case, and continue constructing data for
        // existing cases. In certain scenarios it is possible for cases
        // to be deleted from the system, while labels are not, therefor
        // we may be having labels that are pointing at non-existing cases.
        // if this is the current case, throwing an error will fail the
        // entire case data construction. Ignore label and continue with
        // the next labels that are pointing at valid cases.
        continue;
      }
      const caseTissue = caseObj.tissue;
      const labelTissueConfig = insightsConfig.labels[caseTissue];
      const caseLabelData = labels[caseId];
      caseLabelData.labels = constructLabels(caseLabelData.labels, labelTissueConfig);
      for (const slideId in caseLabelData.slides) {
        const slideLabelData = caseLabelData.slides[slideId];
        slideLabelData.labels = constructLabels(slideLabelData.labels, labelTissueConfig);
      }
    }
    return labels;
  } catch (error) {
    console.log((error as any).message);
  }
};
